import { FieldInputProps, useFormikContext } from "formik";
import React from "react";

import { FieldStateProps } from "../FieldHeader";
import { TextField } from "../TextField";

type PriceInputFieldProps = Readonly<{
  name: string;
  title: string;
  type?: "number" | "string";
  isRequiredField?: boolean;
}> &
  FieldStateProps;

export const PriceInputField = (props: PriceInputFieldProps) => {
  const { name, title, type, isSaving, isRequiredField } = props;
  const { setFieldValue } = useFormikContext();

  const priceAcceptedValuesOnChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    // eslint-disable-next-line
    field: FieldInputProps<any>
  ) => {
    const priceRegex = /[^0-9.]/g;
    const targetValue = e.target.value;
    const rawNumber = targetValue.split(".")[0].replace(/\D/g, "");
    let inputFormattedValue;
    if (!/^[0-9]{1,6}(.[0-9]{0,2})?$/.test(targetValue)) {
      inputFormattedValue = targetValue.slice(0, -1);
      setFieldValue(field.name, inputFormattedValue);
      return field.onChange;
    }

    if (rawNumber.length > 6) {
      inputFormattedValue = targetValue.slice(0, -1).replace(priceRegex, "");
    } else {
      inputFormattedValue = targetValue.replace(priceRegex, "");
    }
    setFieldValue(field.name, inputFormattedValue);
    return field.onChange;
  };

  const priceFormatOnBlur = (
    e: React.ChangeEvent<HTMLInputElement>,
    // eslint-disable-next-line
    field: FieldInputProps<any>
  ) => {
    const targetValue = e.target.value.replace(/[$,]/g, "");
    const targetValueArray = targetValue.split(".");
    let finalValue;
    const usDollarLocal = Intl.NumberFormat("en-US");

    if (!targetValue) {
      return field.onBlur(e);
    }

    if (targetValueArray.length === 1) {
      finalValue = usDollarLocal.format(parseFloat(targetValueArray[0])).concat(".00");
    } else if (targetValueArray.length === 2) {
      finalValue = usDollarLocal
        .format(parseFloat(targetValueArray[0]))
        .concat(".")
        .concat(targetValueArray[1]);
    }

    setFieldValue(field.name, `$${finalValue}`);
    return field.onBlur(e);
  };

  return (
    <TextField
      name={name}
      title={title}
      type={type}
      isRequiredField={isRequiredField}
      isSaving={isSaving}
      customOnChange={priceAcceptedValuesOnChange}
      customOnBlur={priceFormatOnBlur}
    />
  );
};
